var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-button--switch",attrs:{"aria-label":_vm._f("t")('Menu')},on:{"click":function($event){return _vm.toggleMenu()}}},[(!_vm.open)?_c('i',{staticClass:"fas fa-bars"}):_c('i',{staticClass:"fas fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }